import React, { forwardRef } from 'react';
import { color, space, font, radius } from './tokens';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
  selectSize?: 'sm' | 'md' | 'lg';
}

const sizeStyles = {
  sm: { padding: `${space[1]}px ${space[6]}px ${space[1]}px ${space[2]}px`, fontSize: font.size.sm,  minHeight: 32 },
  md: { padding: `${space[2]}px ${space[8]}px ${space[2]}px ${space[3]}px`, fontSize: font.size.base, minHeight: 40 },
  lg: { padding: `${space[3]}px ${space[10]}px ${space[3]}px ${space[4]}px`, fontSize: font.size.lg, minHeight: 48 },
};

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid = false, selectSize = 'md', style, children, disabled, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      aria-invalid={invalid || undefined}
      disabled={disabled}
      style={{
        display:      'block',
        width:        '100%',
        background:   disabled ? color.bg.subtle : color.bg.card,
        color:        color.text.primary,
        border:       `1px solid ${invalid ? color.status.error.border : color.border.strong}`,
        borderRadius: radius.md,
        fontFamily:   font.family.sans,
        appearance:   'none',
        backgroundImage:
          'url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 12 12\'><path fill=\'%236b7280\' d=\'M3 4.5L6 7.5L9 4.5\'/></svg>")',
        backgroundRepeat:   'no-repeat',
        backgroundPosition: 'right 12px center',
        outline:      'none',
        cursor:       disabled ? 'not-allowed' : 'pointer',
        ...sizeStyles[selectSize],
        ...style,
      }}
      {...rest}
    >
      {children}
    </select>
  );
});

export default Select;
